import React from 'react';
import { SitecoreImageField } from 'components/sitecore-fields';

class CompetitionAnswers extends React.Component {

    render() {
        const { answers, value, onChange } = this.props;
        return (
            <ul className="toch-survey__image-list">
                {answers.map((answer) => {
                    return (
                        <li key={answer.text} className="toch-survey__list-item">
                            <button
                                className={`toch-survey__picture-button ${answer.text === value ? 'is-active' : ''}`}
                                type="button"
                                onClick={() => onChange(answer.text)}>
                                <div className="toch-survey__picture-button--wrap">
                                    <SitecoreImageField img={answer.image} className='toch-survey__picture-button--img' />
                                </div>
                                <div className="toch-survey__picture-button--label">{answer.text}</div>
                            </button>
                        </li>
                    );
                })}
            </ul>
        );
    }
}

export default CompetitionAnswers;
